import React from 'react';

import { NwPlusRewardStepStatus } from '@generated-gql/generated-types';

interface Props {
  status: NwPlusRewardStepStatus;
}

const Completed = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <circle cx="8" cy="8" r="7.5" fill="#A8EA4C" stroke="#A8EA4C" />
    <line
      x1="4.51848"
      y1="7.45808"
      x2="7.70588"
      y2="10.5076"
      stroke="#00482F"
      strokeWidth="1.5"
    />
    <path
      d="M6.64307 10.5161L12.1192 5.11573"
      stroke="#00482F"
      strokeWidth="1.5"
    />
  </svg>
);

const Failed = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7.5" fill="#FF9090" stroke="#FF9090" />
    <path
      d="M4.14056 11.1835C3.95315 11.3709 3.95315 11.6748 4.14056 11.8622C4.32796 12.0496 4.63181 12.0496 4.81922 11.8622L7.99895 8.68244L11.2015 11.885C11.389 12.0724 11.6928 12.0724 11.8802 11.885C12.0676 11.6976 12.0676 11.3938 11.8802 11.2064L8.67761 8.00377L11.8622 4.81922C12.0496 4.63181 12.0496 4.32796 11.8622 4.14056C11.6748 3.95315 11.3709 3.95315 11.1835 4.14056L7.99895 7.32511L4.8355 4.16166C4.64809 3.97425 4.34425 3.97425 4.15684 4.16166C3.96943 4.34907 3.96943 4.65292 4.15684 4.84033L7.32028 8.00377L4.14056 11.1835Z"
      fill="black"
    />
  </svg>
);

const Pending = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <circle cx="8" cy="8" r="7.5" fill="#FFC764" stroke="#FFC764" />
    <path d="M4.00098 8L12.001 8" stroke="black" strokeWidth="1.5" />
  </svg>
);

const Default = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7.5" fill="#F7F7F7" stroke="#F7F7F7" />
    <line
      x1="5.04827"
      y1="8.0821"
      x2="8.23566"
      y2="11.1316"
      stroke="#D8D9DA"
      strokeWidth="1.5"
    />
    <path
      d="M7.17285 11.1401L12.649 5.73975"
      stroke="#D8D9DA"
      strokeWidth="1.5"
    />
  </svg>
);

const RewardStepStatusIcon: React.FC<Props> = ({ status }) => {
  const SVGContent =
    {
      [NwPlusRewardStepStatus.Completed]: Completed,
      [NwPlusRewardStepStatus.Failed]: Failed,
      [NwPlusRewardStepStatus.Pending]: Pending,
    }[status] || Default;

  return (
    <div style={{ height: 16, width: 16 }}>
      <SVGContent />
    </div>
  );
};

export default RewardStepStatusIcon;
